import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const getFilters = ({ filters, setFilters }) => {

  const currentYear = new Date().getFullYear();

  const years = [{
    value: 0,
    key: 'Όλα',
  }];

  const yearList = Array.from({ length: currentYear - 2015 + 1 }, (_, index) =>
    (2015 + index).toString(),
  );

  yearList.forEach((y) => {
    years.push({value: y, key: `${y}`,});
  });

  const unpaidStates = [
    {
      status: 'Μερικώς Πληρωμένη',
      value: '-1',
    },
    {
      status: 'Απλήρωτη',
      value: '2',
    },
  ];

  return [
    {title: 'ΑΦΜ',
      details: (
        <>
          <TextField id='outlined-basic' label='ΑΦΜ'
            type='number'
            variant='outlined'
            onChange={(newValue) => {
              setFilters({ ...filters, afm: newValue.nativeEvent.data });
            }}
          />
        </>
      ),
    },
    {
      title: 'Ημερομηνία Βεβαίωσης',
      details: (
        <>
          <DatePicker
            label='Απο:'
            inputFormat='dd/MM/yyyy'
            componentsProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            value={filters.dateFromConfirmation}
            onChange={(newValue) => {
              setFilters({ ...filters, dateFromConfirmation: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderRadius: '0px',
                      borderTop: 'none',
                      borderRight: 'none',
                      borderLeft: 'none',
                    },
                  },
                }}
              />
            )}
          />
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            label='Έως:'
            inputFormat='dd/MM/yyyy'
            value={filters.dateToConfirmation}
            onChange={(newValue) => {
              setFilters({ ...filters, dateToConfirmation: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderRadius: '0px',
                      borderTop: 'none',
                      borderRight: 'none',
                      borderLeft: 'none',
                    },
                  },
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: 'Ημερομηνία Είσπραξης',
      details: (
        <>
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            label='Απο:'
            inputFormat='dd/MM/yyyy'
            value={filters.dateFromPayment}
            onChange={(newValue) => {
              setFilters({ ...filters, dateFromPayment: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderRadius: '0px',
                      borderTop: 'none',
                      borderRight: 'none',
                      borderLeft: 'none',
                    },
                  },
                }}
              />
            )}
          />
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            label='Έως:'
            inputFormat='dd/MM/yyyy'
            value={filters.dateToPayment}
            onChange={(newValue) => {
              setFilters({ ...filters, dateToPayment: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderRadius: '0px',
                      borderTop: 'none',
                      borderRight: 'none',
                      borderLeft: 'none',
                    },
                  },
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: 'Έτος Οφειλής',
      details: (
        <>
          <Select
            fullWidth
            sx={{ marginTop: '15px', textAlign: 'left', minWidth: 200 }}
            id='year'
            value={filters.yearOfConfirmation}
            inputProps={{ 'aria-label': 'Without label' }}
            onChange={(event) => {
              setFilters({ ...filters, yearOfConfirmation: event.target.value });
            }}
          >
            {years.map((option) => {
              return (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              );
            })}
          </Select>
        </>
      ),
    },
    {
      title: 'Κατάσταση Πληρωμής',
      details: (
        <>
          <FormControl
            variant='standard'
            sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          >
            <InputLabel id='select_paid'>Κατάσταση</InputLabel>
            <Select
              IconComponent={
                filters.paidStatus != ''
                  ? () => (
                    <ClearIcon
                      size='small'
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setFilters({ ...filters, paidStatus: '' });
                      }}
                    />
                  )
                  : undefined
              }
              labelId='select_paid'
              value={filters.paidStatus}
              onChange={(event) => {
                setFilters({ ...filters, paidStatus: event.target.value });
              }}
            >
              {unpaidStates.map((it, index) => (
                <MenuItem key={index} value={it.value}>
                  {it.status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      ),
    },
  ];
};

export default getFilters;
